/// <reference path='../_all.ts' />

module shoppinglist {

  export enum ShoppingListType {
    Merkliste = 1,
    Warenkorb = 2,
    GeteilteMerkliste = 3
  }

  export interface IShoppingListService {
    getLists() : { [id: string] : ShoppingList; };
    getList(listId) :ShoppingList;
    getLocalSetting(key, defaultValue) :any ;
    setLocalSetting(key: string, value : any) :void ;
    addToList(partid : string, listType : ShoppingListType, qty :  number, onSuccess : (data : ShoppingList) => void) :ng.IHttpPromise<ShoppingList> ;
    updateQty(listid : string, requestid) :void ;
    updateQtyNetwork(listid : string, parts, requestid) : ng.IHttpPromise<ShoppingList> ;
    updateQtyDebounced(listid : string) :void ;
    fetchLists(id, onSuccess) :ng.IHttpPromise<ShoppingList[]> ;
    getListsById(listid : string) :ng.IHttpPromise<ShoppingList> ;
    shareList(listid : string, sendMail, eMailAddress, message, onSuccess) :ng.IHttpPromise<ShoppingList> ;
    appendToList(listid : string, listType: ShoppingListType) :ng.IHttpPromise<ShoppingList> ;
    checkForUpdates(serverState, onFetched) :boolean; 
    getTotalQty(list) :number ;
    calculateAvailability(list) :any ;
    getTotal(list, yourPriceEnabled : boolean) :number;
    getQtySummary(list) :string ;  
    
    show(listType: ShoppingListType, target : EventTarget) : void;    
    hide(target? : EventTarget) : void;    
    subscribeOnShowChange(scope : ng.IScope, callback : (event:ng.IAngularEvent, visibleListType: number, target: EventTarget) => void) : void;    
    
    subscribeOnUpdated(scope : ng.IScope, callback : (event:ng.IAngularEvent, list : ShoppingList) => void) : void;    

    


  }
}